import React from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import styled from "styled-components";

import InputRequest from "./../components/InputRequest";
import InnerLayout from "./../components/InnerLayout";
import FieldSet from "./../components/FieldSet";
import TextInput from "./../components/TextInput";
import InputList from "./../components/InputList";
import Checkbox from "./../components/Checkbox";
import TextArea from "./../components/TextArea";

const MainScreenStyle = styled.div`
  display: grid;
  grid-template-rows: 50px 1fr;
`;

const getCommunicationsQuery = gql`
  query getCommunication($communicationId: ID!) {
    getCommunication(amqpCommunicationId: $communicationId) {
      id
      name
      sender {
        exchange
        routingKey
        headers {
          key
          value
        }
        properties {
          key
          value
        }
        payload
      }
      receiver {
        queue
        messages
        durable
        autoDelete
        binding
      }
    }
  }
`;

const MainScreen = () => {
  const { loading, data, error } = useQuery(getCommunicationsQuery, {
    variables: { communicationId: "008603ca-13ae-4ad9-83d0-7ea61bfbead8" }
  });

  return (
    <MainScreenStyle>
      {loading && <p>loading</p>}
      {error && <h1>Error</h1>}
      {data && data.getCommunication && (
        <div>
          <InputRequest defaultValue={data.getCommunication.name} />
          <InnerLayout>
            <FieldSet legend="Publisher">
              <TextInput
                label="Exchange"
                value={data.getCommunication.sender.exchange}
              ></TextInput>
              <TextInput
                label="Routing key"
                value={data.getCommunication.sender.routingKey}
              ></TextInput>
              <InputList
                title="headers"
                items={data.getCommunication.headers}
              ></InputList>
              <InputList
                title="properties"
                items={data.getCommunication.properties}
              ></InputList>
              <TextArea
                label="Payload"
                value={JSON.stringify(
                  data.getCommunication.sender.payload,
                  null,
                  2
                )}
              />
              <button>Send</button>
            </FieldSet>
            <FieldSet legend="Consumer">
              <TextInput
                label="Queue"
                value={data.getCommunication.receiver.queue}
              ></TextInput>
              <TextInput
                label="Binding"
                value={data.getCommunication.receiver.binding}
              ></TextInput>
              <Checkbox
                label="Durable"
                checked={data.getCommunication.receiver.durable}
              />
              <Checkbox
                label="Auto-delete"
                checked={data.getCommunication.receiver.autoDelete}
              />
              <button>Ack a new message</button>
            </FieldSet>
          </InnerLayout>
        </div>
      )}
    </MainScreenStyle>
  );
};

export default MainScreen;
